module.exports = __webpack_public_path__ + "img/pick5.68ee60df.png";